import { getConfig } from '../../config';
import type { TranslationDataObj } from './type';

const { passwordMinimumLength } = getConfig();
export const data: TranslationDataObj = {
  errors: {
    CODE_INVALID: {
      en: 'Code invalid',
      fr: 'Code invalide',
    },
    ONLY_NUMBERS_ALLOWED: {
      en: 'Only numbers allowed',
      fr: 'Seuls les chiffres sont autorisés',
    },
    USER_INVALID_EMAIL: {
      en: 'Please add a valid email',
      fr: 'Veuillez ajouter une adresse e-mail valide',
    },
    USER_INVALID_FIRST_NAME: {
      en: 'Please add a valid name',
      fr: 'Veuillez ajouter un prénom valide',
    },
    USER_INVALID_LAST_NAME: {
      en: 'Please add a valid surname',
      fr: 'Veuillez ajouter un nom de famille valide',
    },
    USER_INVALID_LANGUAGE: {
      en: 'Valid language is required',
      fr: 'Une langue valide est requise',
    },
    PASSWORD_MINIMUM: {
      en: `Must be at least ${passwordMinimumLength} characters long`,
      fr: `Doit contenir au moins ${passwordMinimumLength} caractères`,
    },
    ORG_INVALID_NAME: {
      en: 'Valid name is required',
      fr: 'Un nom valide est requis',
    },
    ORG_INVALID_PHONE: {
      en: 'Invalid phone number',
      fr: 'Numéro de téléphone invalide',
    },
    ORG_INVALID_COUNTRY: {
      en: 'Country must be a 2-character code',
      fr: 'Le pays doit être un code de 2 caractères',
    },
    ORG_INVALID_EMAIL: {
      en: 'Invalid email',
      fr: 'E-mail invalide',
    },
    ORG_INVALID_WEBSITE: {
      en: 'Invalid website',
      fr: 'Site web invalide',
    },
    BRAND_INVALID_NAME: {
      en: 'Valid name is required',
      fr: 'Un nom valide est requis',
    },
    INVALID_CODE: {
      en: 'Enter a valid code',
      fr: 'Saisissez un code valide',
    },
    'Incorrect code': {
      en: 'Enter a valid code',
      fr: 'Saisissez un code valide',
    },
    FIELD_INVALID_URL: {
      en: 'Please enter a valid URL',
      fr: 'Veuillez saisir une URL valide',
    },
    FIELD_REQUIRED: {
      en: 'Please enter text',
      fr: 'Veuillez saisir du texte',
    },
    FIELD_REQUIRED_B: {
      en: 'Field is required',
      fr: 'Ce champ est requis',
    },
    Required: {
      en: 'Field is required',
      fr: 'Ce champ est requis',
    },
    DELETE_EXTRA_INFO_FIELD_REQUIRED: {
      en: 'Field requires a minimum of 30 characters',
      fr: 'Ce champ doit contenir au moins 30 caractères',
    },
    FIELD_DOES_NOT_MATCH: {
      en: 'Please enter the correct text',
      fr: 'Veuillez saisir le texte correct',
    },
    FIELD_USAGE_RANGE_REQUIRED: {
      en: 'Please enter all usage range',
      fr: `Veuillez saisir toutes les plages d'utilisation`,
    },
    FIELD_INVALID_USAGE_RANGE_COMPARISON: {
      en: 'Range minimum must be less than range maximum',
      fr: 'La valeur minimale doit être inférieure à la valeur maximale',
    },
    TITLE_REQUIRED: {
      en: 'Title is required',
      fr: 'Le titre est requis',
    },
    CONTENT_REQUIRED: {
      en: 'Content is required',
      fr: 'Le contenu est requis',
    },
    INVALID_FILE_FORMAT: {
      en: 'Invalid file format',
      fr: 'Format de fichier invalide',
    },
    FILE_TOO_LARGE: {
      en: 'File too large',
      fr: 'Fichier trop grand',
    },
    FILE_REQUIRED: {
      en: 'File is required',
      fr: 'Le fichier est requis',
    },
    CONTENT_LENGTH_VALUE_MIN: {
      en: 'Minimum 50 words',
      fr: 'Minimum 50 mots',
    },
    CONTENT_LENGTH_VALUE_MAX: {
      en: 'Maximum 5000 words',
      fr: 'Maximum 5000 mots',
    },
    BRAND_INVALID_COUNTRY: {
      en: 'Please select a country or country code is wrong',
      fr: 'Veuillez sélectionner un pays ou le code pays est incorrect',
    },
    BRAND_INVALID_LANGUAGE: {
      en: 'Please select a language or language code is wrong',
      fr: 'Veuillez sélectionner une langue ou le code langue est incorrect',
    },
    LANGUAGE_REQUIRED: {
      en: 'Language is required',
      fr: 'La langue est requise',
    },
    COUNTRY_REQUIRED: {
      en: 'Country is required',
      fr: 'Le pays est requis',
    },

    // TODO: look into these errors: https://clerk.com/docs/errors/sign-up
    // Clerk related
    'Password has been found in an online data breach. For account safety, please use a different password.':
      {
        en: 'Password has been found in an online data breach. For account safety, please use a different password.',
        fr: 'Le mot de passe a été trouvé dans une fuite de données en ligne. Pour la sécurité de votre compte, veuillez utiliser un mot de passe différent.',
      },
    'Enter code': {
      en: 'Enter code',
      fr: 'Saisir le code',
    },
    'Unable to authenticate this browser for your development instance. Check your Clerk cookies and try again. If the issue persists reach out to support@clerk.com.':
      {
        en: 'Something went wrong. Please contact support.',
        fr: 'Une erreur s’est produite. Veuillez contacter le support.',
      },
    'That email address is taken. Please try another.': {
      en: 'That email address is taken. Please try another.',
      fr: 'Cette adresse e-mail est déjà prise. Veuillez en essayer une autre.',
    },
    'Something went wrong, please try again later.': {
      en: 'Something went wrong. Please contact support.',
      fr: 'Une erreur s’est produite. Veuillez contacter le support.',
    },
    'You are not allowed to access this application.': {
      en: 'You are not allowed to access this application.',
      fr: 'Vous n’êtes pas autorisé à accéder à cette application.',
    },
    "You're currently in single session mode. You can only be signed into one account at a time.": {
      en: "You're currently in single session mode. You can only be signed into one account at a time.",
      fr: 'Vous êtes actuellement en mode session unique. Vous ne pouvez être connecté qu’à un seul compte à la fois.',
    },
    'Password is incorrect. Try again, or use another method.': {
      en: 'Password is incorrect. Try again, or use another method.',
      fr: 'Le mot de passe est incorrect. Réessayez, ou utilisez une autre méthode.',
    },
    POST_SLUG_INVALID: {
      en: 'Only lowercase letters, numbers, and hyphens allowed',
      fr: 'Uniquement des lettres minuscules, chiffres et tirets',
    },

    // TODO: Manage Zod Errors
    FIELD_INVALID: {
      en: 'This field is invalid',
      fr: 'Ce champ est invalide',
    },

    ONBOARDING_INVALID_URL: {
      en: 'Please enter a valid URL, or skip to do it later',
      fr: 'Veuillez saisir une URL valide, ou passez cette étape pour le faire plus tard',
    },

    BRAND_INVALID_URL: {
      en: 'Please enter a valid URL',
      fr: 'Veuillez saisir une URL valide',
    },

    ONBOARDING_INVALID_BRAND_NAME: {
      en: 'Brand name needs to be at least 2 characters',
      fr: 'Le nom de la marque doit comporter au moins 2 caractères',
    },

    FIELD_INVALID_BRAND_NAME: {
      en: 'Brand name is incorrect',
      fr: 'Le nom de la marque est incorrect',
    },

    FIELD_PASSWORDS_DO_NOT_MATCH: {
      en: 'Please make sure the passwords match',
      fr: 'Veuillez vous assurer que les mots de passe correspondent',
    },

    // APP Errors
    KEYWORD_REQUIRED: {
      en: 'Please enter a keyword',
      fr: 'Veuillez entrer un mot-clé',
    },
    PROMPT_REQUIRED: {
      en: 'Please enter a prompt',
      fr: 'Veuillez entrer un prompt',
    },
    UNABLE_TO_GENERATE_KEYWORD: {
      en: 'Unable to generate keyword. Please try again.',
      fr: 'Impossible de générer le mot-clé. Veuillez réessayer.',
    },
    UNABLE_TO_GENERATE_PROMPT: {
      en: 'Unable to generate prompt. Please try again.',
      fr: 'Impossible de générer le prompt. Veuillez réessayer.',
    },
    URL_REQUIRED: {
      en: 'Please enter a URL',
      fr: 'Veuillez entrer une URL',
    },

    URL_INVALID: {
      en: 'Please enter a valid URL (e.g. http://www.website.com)',
      fr: 'Veuillez entrer une URL valide (ex. http://www.website.com)',
    },

    INVALID_URL: {
      en: 'Please enter a valid URL (e.g. http://www.website.com)',
      fr: 'Veuillez entrer une URL valide (ex. http://www.website.com)',
    },

    INVALID_TOKEN: {
      en: 'Invalid token',
      fr: 'Token invalide',
    },

    NAME_REQUIRED: {
      en: 'Name is required',
      fr: 'Le nom est requis',
    },

    URL_INVALID_HTTPS: {
      en: 'Please enter a valid HTTPS URL (e.g. https://www.website.com)',
      fr: 'Veuillez entrer une URL HTTPS valide (ex. https://www.website.com)',
    },

    'Identifier is invalid.': {
      en: 'Wrong email and/or password',
      fr: 'Adresse e-mail et/ou mot de passe incorrect(s)',
    },
    "Couldn't find your account.": {
      en: 'Wrong email and/or password',
      fr: 'Adresse e-mail et/ou mot de passe incorrect(s)',
    },
    'String must contain at most 1000 character(s)': {
      en: 'Your text must contain at most 1000 character(s)',
      fr: 'Votre texte doit contenir au plus 1000 caractères',
    },
    'String must contain at most 2000 character(s)': {
      en: 'Your text must contain at most 2000 character(s)',
      fr: 'Votre texte doit contenir au plus 2000 caractères',
    },
    'String must contain at most 1500 character(s)': {
      en: 'Your text must contain at most 1500 character(s)',
      fr: 'Votre texte doit contenir au plus 1500 caractères',
    },
    'String must contain at most 4000 character(s)': {
      en: 'Your text must contain at most 4000 character(s)',
      fr: 'Votre texte doit contenir au plus 4000 caractères',
    },
    'String must contain at most 5000 character(s)': {
      en: 'Your text must contain at most 5000 character(s)',
      fr: 'Votre texte doit contenir au plus 5000 caractères',
    },
    'We were unable to complete a GET request for this Client. No sign up attempt was found. Please try again.':
      {
        en: 'We were unable to complete a GET request for this Client. No sign up attempt was found. Please try again.',
        fr: 'Nous n’avons pas pu compléter la requête GET pour ce Client. Aucune tentative d’inscription n’a été trouvée. Veuillez réessayer.',
      },
    "You're already signed in.": {
      en: "You're already signed in.",
      fr: 'Vous êtes déjà connecté.',
    },
    'Enter a name': {
      en: 'Enter a name',
      fr: 'Entrez un nom',
    },
    'Select a type': {
      en: 'Please Select a type',
      fr: 'Sélectionner un type',
    },
    'Invalid discount code': {
      en: 'Invalid discount code',
      fr: 'Code de réduction invalide',
    },
    'Discount code already used': {
      en: 'Discount code already used',
      fr: 'Code de réduction déjà utilisé',
    },
    'Password is incorrect. Try again or use another method.': {
      en: 'Password is incorrect. Try again or use another method',
      fr: 'Le mot de passe est incorrect. Réessayez ou utilisez une autre méthode',
    },
    'Passwords must be 8 characters or more.': {
      en: 'Passwords must be 8 characters or more.',
      fr: 'Les mots de passe doivent comporter 8 caractères ou plus',
    },
    'Too many requests. Please try again in a bit.': {
      en: 'Too many requests. Please try again in a bit',
      fr: 'Trop de demandes. Veuillez réessayer dans un instant',
    },

    // PLAN FEATURES ERRORS
    ERROR_FEATURE_AI_CONTENT_GAP_MISSING: {
      en: "Your organization don't have access to AI content gaps",
      fr: 'Votre organisation n’a pas accès aux lacunes de contenu IA',
    },
    ERROR_FEATURE_AI_METRICS_MISSING: {
      en: "Your organization don't have access to AI metrics",
      fr: 'Votre organisation n’a pas accès aux métriques IA',
    },
    ERROR_FEATURE_REFRESH_CONTENT_LIGHT_MISSING: {
      en: "Your organization don't have access to light refresh content",
      fr: 'Votre organisation n’a pas accès au rafraîchissement léger de contenu',
    },
    ERROR_FEATURE_REFRESH_CONTENT_MAJOR_MISSING: {
      en: "Your organization don't have access to major refresh content",
      fr: 'Votre organisation n’a pas accès au rafraîchissement majeur de contenu',
    },
    ERROR_FEATURE_SUPPORTING_MATERIALS_MISSING: {
      en: "Your organization can't use supporting materials",
      fr: 'Votre organisation ne peut pas utiliser les supports',
    },
    ERROR_FEATURE_ENABLED_ARTICLES_MISSING: {
      en: "Your organization don't have access to content",
      fr: 'Votre organisation n’a pas accès au contenu',
    },
    ERROR_FEATURE_ENABLED_PRODUCTS_MISSING: {
      en: "Your organization don't have access to products",
      fr: 'Votre organisation n’a pas accès aux produits',
    },
    ERROR_FEATURE_ENABLED_COLLECTIONS_MISSING: {
      en: "Your organization don't have access to collections",
      fr: 'Votre organisation n’a pas accès aux collections',
    },
    ERROR_FEATURE_AI_OVERVIEW_MISSING: {
      en: "Your organization don't have access to an AI provider",
      fr: 'Votre organisation n’a pas accès à un fournisseur d’IA',
    },
    ERROR_FEATURE_MAX_TEAM_USER_COUNT_INSUFFICIENT: {
      en: 'Your organization have reached the team members limit',
      fr: 'Votre organisation a atteint la limite de membres de l’équipe',
    },
    ERROR_FEATURE_MAX_BRAND_COUNT_INSUFFICIENT: {
      en: 'Your organization have reached the brands limit',
      fr: 'Votre organisation a atteint la limite de marques',
    },
    ERROR_SUBSCRIPTION_CANCELLED: {
      en: 'Unavailable while your subscription is cancelled',
      fr: 'Indisponible lorsque votre abonnement est annulé',
    },
    ERROR_INSUFFICIENT_CREDITS: {
      en: 'Your organization does not have enough credits',
      fr: "Votre organisation n'a pas assez de crédits",
    },
    UNREACHABLE_PRODUCT_IMAGE: {
      en: 'Product images are missing or could not be reached.',
      fr: 'Des images produit sont manquantes ou inaccessibles.',
    },
    ERROR_LIMIT_ARTICLE_TRIALING: {
      en: 'Reached the limit of content while trialing',
      fr: 'Atteint la limite de contenu pendant la période d’essai',
    },
    ERROR_LIMIT_ARTICLE_FREE: {
      en: 'Reached the limit of content while on free account',
      fr: 'Vous avez atteint la limite de contenu avec un compte gratuit',
    },
    ERROR_UNABLE_TO_CHANGE_ARTICLE: {
      en: 'Unable to change content',
      fr: 'Impossible de modifier le contenu',
    },
  },
};
